export default __webpack_public_path__ + "static/media/selected-layout-grid.5d27176c.svg";